// src/components/NewsTicker.js
import React from 'react';
import './NewsTicker.css';

const NewsTicker = ({ items, speed = 25 }) => {
  // Default news items if none provided
  const defaultItems = [
    "🚀 Portfolio Web App launched — September 20, 2025",
    "💼 Open for consulting opportunities",
    "📊 Developing backend for the upcoming analytics dashboard",
    "🎯 Specializing in Analytics, Automation, and Data Visualization",
    "✨ Portfolio update coming soon — backend setup in progress before soft launch"
  ];

  const newsItems = items || defaultItems;

  return (
    <div className="news-ticker">
      <div className="news-ticker-wrap">
        <div className="news-ticker-move" style={{ animationDuration: `${speed}s` }}>
          {/* Duplicate the items twice to create seamless loop */}
          {[...newsItems, ...newsItems, ...newsItems, ...newsItems].map((item, index) => (
            <div key={index} className="news-ticker-item">
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;

